import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

import { AssessmentSummary, SINGLE_ROW_HEADER, DELETE_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility } from '../shared';
import { CommonUtility, ServerConstantsService, DataService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { audit } from 'rxjs/operators';

@Component({
  selector: 'app-skill',
  templateUrl: './skill.component.html',
  styleUrls: ['./skill.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class SkillComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText: ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  isDisabled = false;
  readOnly = false;
  tabIndex: any = '-1';

  licenseSw: String;
  skillsSw: String;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  assessmentId: Number;
  assessment: AssessmentSummary;
  personId: Number;
  skills: Skills[] = [];
  removedSkills: Skills[] = [];
  statusMap: any;
  programMap: any;
  serverConstants: any;
  sharedData: any;
  programCd: String;
  userActionNotificationsMap: any;
  show = false;
  isCurrentEnrollment:Boolean = false;
  skillsColumnDefs: any;
  skillsAuditColumnDefs: any;
  context: any;
  strengthTypeDescJson: any;
  strengthTypeDescReverseJson: any;
  skillArray = [];
  skillTypeDescJson: any;
  skillTypeDescReverseJson: any;
  defaultColDef;
  editType;
  gridApi;
  gridColumnApi;
  gridStrengthApi;
  gridStrengthColumnApi;

  strengthColumnDefs: any;
  strengthsAuditColumnDefs: any;
  strengthContext: any;
  strengths: Strength[] = [];
  strengthArray = [];
  removedStrength: Strength[] = [];
  userFullName;
  rowSelection;
  validationError = [];
  showError = false;
  strengthShowError = false;
  strengthValidationError = [];
  isShowStyle = false;
  private tabToNextCell;
  private navigateToNextCell;
  isChangeDetected = false;

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('ASMNT') == undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get('ASMNT').innerNavPages.find(x => x.pageId === 'ASMSS').readOnly;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);
    const programs = this.data.getValueFromSharedDataMap('PROGRAMS');
    this.programMap = this.commonUtil.createNativeMapFromList(programs);

    const strengthTypeDesc = this.data.getValueFromSharedDataMap('StrengthTypeDesc');
    this.strengthTypeDescJson = this.commonUtil.createNativeMapFromList(strengthTypeDesc);
    this.strengthTypeDescReverseJson = this.commonUtil.createReverseNativeMapFromList(strengthTypeDesc);
    strengthTypeDesc.forEach(element => {
      this.strengthArray.push(element.name);
    });

    const skillTypeDesc = this.data.getValueFromSharedDataMap('SkillTypeDesc');
    skillTypeDesc.forEach(element => {
      this.skillArray.push(element.name);
    });
    this.skillTypeDescReverseJson = this.commonUtil.createReverseNativeMapFromList(skillTypeDesc);
    this.skillTypeDescJson = this.commonUtil.createNativeMapFromList(skillTypeDesc);

    // Shared object access to get personId and assessmentId
    const sharedData = this.dataService.getSharedDataObject();

    if (sharedData.get('assessmentId') !== null && sharedData.get('assessmentId') !== undefined) {
      this.assessmentId = Number(sharedData.get('assessmentId'));
    }

    if (sharedData.get('current_user_full_name') !== null && sharedData.get('current_user_full_name') !== undefined) {
      this.userFullName = sharedData.get('current_user_full_name');
    }

    this.getColumnDefinitions();
    this.getColumnDefinitionsStrength();

    // Audits
    this.getSkillAuditColumnDefinitions();
    this.getStrengthColumnDefinitions();

    if (this.assessmentId > 0) {
      const request = new RequestLoad(this.assessmentId);
      this.load(request);

    }


    if (sharedData.get('selectedEnrollmentEndDt') !== null && sharedData.get('selectedEnrollmentEndDt') !== undefined
    && sharedData.get('selectedEnrollmentEndDt') !== "Current") {
     this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

    console.log('isDisabled : ' + this.isDisabled);
    console.log('readOnly : ' + this.readOnly);
    console.log('isCurrentEnrollment : ' + this.isCurrentEnrollment);
    console.log('selectedEnrollmentEndDt : ' + sharedData.get('selectedEnrollmentEndDt'));

  }

  getColumnDefinitions() {
    this.skillsColumnDefs = [
      {
        headerName: 'Skill', field: 'skillCd', editable: !(this.isDisabled || this.readOnly), cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.skillArray,

        }, cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === 'Pick an option') {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      { headerName: 'Skill Created By', field: 'createdUser' },
      { headerName: 'Action', width: 140, field: '', cellRenderer: this.getSkillActionButtons ,
        suppressFilter: true,
        suppressSorting: true},
    ];

    this.context = {
      component: this,
    };
    this.rowSelection = 'multiple';
    this.tabToNextCell = function tabToNextCell(params) {
      let nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getSkillAuditColumnDefinitions() {
    this.skillsAuditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 195,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Skill',
        width: 110,
        field: 'skillCd',
        refData: this.skillTypeDescJson,
        tooltip: (params) => {
          const skillTypeDescMap = params.context.skillTypeDescJson;
          const skillTypeCode = params.data.skillCd;
          const skillType = skillTypeDescMap[skillTypeCode];
          return skillType;
        }
      },
    ];
  }

  onSkillGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();

  }

  onGridStrengthReady(params) {
    this.gridStrengthApi = params.api;
    this.gridStrengthColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();

  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      // this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
      this.gridStrengthApi.sizeColumnsToFit();
    }
  }

  addEventListenerToSearch(event) {
    let tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.skills.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    let index = this.gridApi.getFirstDisplayedRow();
    let rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    let firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);

    //this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }

  addEventListenerToStrength(event) {
    let tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.strengths.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex1();
  }
  setDisplayedRowAtIndex1() {
    // get the first row
    let index = this.gridStrengthApi.getFirstDisplayedRow();
    let rowNode = this.gridStrengthApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridStrengthApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    let firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridStrengthApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridStrengthApi.setFocusedCell(index, firstCol);

    //this.gridStrengthApi.paginationGoToPage( Math.floor(index / 10) );
  }

  getColumnDefinitionsStrength() {
    this.strengthColumnDefs = [

      {
        headerName: 'Strength', field: 'strengthCd', editable: !(this.isDisabled || this.readOnly), cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.strengthArray,

        }, cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === 'Pick an option') {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      { headerName: 'Strength Created By', field: 'createdUser' },
      { headerName: 'Action', width: 140, field: '', cellRenderer: this.getStrengthActionButtons ,
        suppressFilter: false,
        suppressSorting: false},
    ];
    this.tabToNextCell = function tabToNextCell(params) {
      let nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getStrengthColumnDefinitions() {
    this.strengthsAuditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 195,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Strength',
        width: 110,
        field: 'strengthCd',
        refData: this.strengthTypeDescJson,
        tooltip: (params) => {
          const strengthTypeDescMap = params.context.strengthTypeDescJson;
          const strengthTypeCode = params.data.strengthCd;
          const strengthType = strengthTypeDescMap[strengthTypeCode];
          return strengthType;
        }
      }
    ];
  }

  reset() {
    if (this.assessmentId > 0) {

      this.load(new RequestLoad(this.assessmentId));

    }
  }

  radioTestAndScore() {
    if (this.skillsSw === 'Y') {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  getSkillActionButtons(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');
    // Delete Button
    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute('class', 'disabled');
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteSkill(params.data.assessment.id);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.deleteSkill(params.data.assessment.id);
      } else if (event.keyCode == 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute('tabindex', '0');
    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');

    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentSkill');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.skillsAuditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Skills Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentSkill');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.skillsAuditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Skills Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory']);
      }

    });
    auditElement.setAttribute('tabindex', '0');
    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);
    return divRow;
  }

  getStrengthActionButtons(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');
    divRow.setAttribute('tabindex', '-1');
    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute('class', 'disabled');
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteStrength(params.data.assessment.id);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.deleteStrength(params.data.assessment.id);
      } else if (event.keyCode == 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });
    element.setAttribute('tabindex', '0');
    divRow.appendChild(element);
    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');
    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentStrength');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.strengthsAuditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Strengths Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentStrength');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.strengthsAuditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Strengths Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory']);
      }

    });
    auditElement.setAttribute('tabindex', '0');
    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);
    return divRow;
  }

  load(request) {
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/loadObjects/skill', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment-Skills & Strengths', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data !== undefined) {
            this.skills = data.skills;
            this.skills.forEach(selectedRow => {
              selectedRow.skillCd = this.skillTypeDescJson[selectedRow.skillCd];

            });
            this.strengths = data.strengths;
            this.strengths.forEach(selectedRow => {
              selectedRow.strengthCd = this.strengthTypeDescJson[selectedRow.strengthCd];

            });
            this.assessment = data.assessment;
            if (this.assessment !== undefined) {
              if (this.assessment.statusCd !== undefined && (this.assessment.statusCd === 'CO') || (this.assessment.statusCd === 'CN')) {
                this.isDisabled = true;
                this.tabIndex = '0';
                this.getColumnDefinitions();
                this.getColumnDefinitionsStrength();
              }

              this.skillsSw = this.assessment.skillSw;
              if (this.skillsSw === 'Y') {
                this.show = true;
              } else {
                this.show = false;
              }
              this.licenseSw = this.assessment.drivingLicenseSw;
            }
          } else {
            this.skills = [];
            this.strengths = [];
          }

          this.validationError = [];
          this.strengthValidationError = [];
          this.showError = false;
          this.strengthShowError = false;
        }
      }, response => {

        this.notificationService.error('Assessment-Skills & Strengths', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  addStrength() {
    const response = this.gridStrengthApi.updateRowData({ add: [new Strength(this.assessment, 'N', this.userFullName)] });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridStrengthApi.setFocusedCell(index, 'strengthCd');
    this.gridStrengthApi.startEditingCell({
      rowIndex: index,
      colKey: 'strengthCd'
    });
    this.gridStrengthApi.paginationGoToPage( Math.floor(index / 10) );
  }

  deleteStrength(assessmentId) {
    const selectedData = this.gridStrengthApi.getSelectedRows();
    this.gridStrengthApi.updateRowData({ remove: selectedData });

    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedStrength.push(element);
      }
    });
  }

  addSkills() {
    const response = this.gridApi.updateRowData({ add: [this.createNewRowData()] });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, 'skillCd');
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: 'skillCd'
    });

    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }

  createNewRowData() {
    const newSkill: Skills = new Skills(this.assessment, 'N', this.userFullName);
    return newSkill;
  }

  deleteSkill(assessmentId) {
    const selectedData: Skills[] = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedData });
    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedSkills.push(element);
      }
    });
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  saveAll() {
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    this.isChangeDetected = false;
    let allSkills = [];
    let allStrength = [];
    if (this.gridApi !== undefined) {
      this.gridApi.stopEditing();
      this.gridStrengthApi.stopEditing();
      this.isShowStyle = true;
      this.gridApi.redrawRows();
      this.isShowStyle = false;
      this.gridApi.selectAll();
      allSkills = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();
      this.validationError = [];
      this.showError = false;
      let errorIndex = 0;
      let isHeaderPushed = false;
      allSkills.forEach(selectedRow => {
        ++errorIndex;
        let errorText = '';
        if (selectedRow.skillCd === undefined || selectedRow.skillCd === 'Pick an option') {
          errorText = 'Skill, ';
        }
        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.validationError.push('Following fields are mandatory:');
          }
          errorText = errorText.substring(0, errorText.length - 2);
          this.validationError.push('Row ' + errorIndex + ': ' + errorText);
          this.showError = true;
        }

      });

      this.strengthValidationError = [];
      this.strengthShowError = false;
      this.gridStrengthApi.selectAll();
      allStrength = this.gridStrengthApi.getSelectedRows();
      this.gridStrengthApi.deselectAll();
      errorIndex = 0;
      isHeaderPushed = false;
      allStrength.forEach(selectedRow => {
        ++errorIndex;
        let errorText = '';
        if (selectedRow.strengthCd === undefined || selectedRow.strengthCd === 'Pick an option') {
          errorText = 'Strength, ';
        }
        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.strengthValidationError.push('Following fields are mandatory:');
          }
          errorText = errorText.substring(0, errorText.length - 2);
          this.strengthValidationError.push('Row ' + errorIndex + ': ' + errorText);
          this.strengthShowError = true;
        }

      });

    }
    if (!this.showError && !this.strengthShowError) {
      this.removedSkills.forEach(element => {
        allSkills.push(element);
      });
      this.removedStrength.forEach(element => {
        allStrength.push(element);
      });

      allStrength.forEach(selectedRow => {
        selectedRow.strengthCd = this.strengthTypeDescReverseJson[selectedRow.strengthCd];
      });
      allSkills.forEach(selectedRow => {
        selectedRow.skillCd = this.skillTypeDescReverseJson[selectedRow.skillCd];
      });
      this.assessment.skillSw = this.skillsSw;
      this.assessment.drivingLicenseSw = this.licenseSw;

      if (this.skillsSw === 'N' || (this.skillsSw === 'Y' && (allSkills.length > 0 || allStrength.length > 0))) {
        const request = new RequestLoadAll(allSkills, allStrength, this.assessment);
        this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/saveSkills', request).subscribe(
          (data) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Assessment-Skills & Strengths', this.userActionNotificationsMap.ERROR);
            } else {
              this.isChangeDetected = false;
              this.notificationService.success('Assessment-Skills & Strengths', this.userActionNotificationsMap.ADD);
              if (this.assessmentId > 0) {

                this.load(new RequestLoad(this.assessmentId));
                this.removedSkills = [];
                this.removedStrength = [];

              }
            }
          }, response => {

            this.notificationService.error('Assessment-Skills & Strengths', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
      } else {
        this.notificationService.warn('Assessment-Skills & Strengths', 'Please add either one Skill or Strength');
      }
    }
  }
}

class RequestLoad {
  constructor(
    public id: Number,

  ) {
  }
}

class Skills {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public createdUser: String,
    public skillCd?: string,

    public id?: any,
    public recordVersion?: number

  ) {
  }
}

class Strength {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public createdUser: String,
    public strengthCd?: string,
    public recordVersion?: number,
    public id?: any,

  ) {
  }
}

class RequestLoadAll {
  constructor(
    public skills: any,
    public strengths: any,
    public assessment: AssessmentSummary,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/skill/skill.component.ts